<div class="topline">
  <h2>Subscription Dunning</h2>
</div>

<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input
      matInput
      [(ngModel)]="searchValue"
      (ngModelChange)="queueFilters()"
      placeholder="Search by user, email, vendor, or product"
      >
    @if (searchValue) {
      <button mat-icon-button matSuffix aria-label="Clear search" (click)="searchValue = ''; queueFilters()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="state-filter">
    <mat-label>State</mat-label>
    <mat-select [(ngModel)]="selectedState" (selectionChange)="queueFilters()">
      @for (option of stateOptions; track option) {
        <mat-option [value]="option.value">{{option.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="filter-actions">
    <button mat-stroked-button color="primary" (click)="clearFilters()">Clear</button>
  </div>
</div>

<div class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="updated">
      <th mat-header-cell *matHeaderCellDef>Updated</th>
      <td mat-cell *matCellDef="let item">
        {{getUpdatedAt(item) ? (getUpdatedAt(item) | date:'medium') : '-'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let item">
        <div>{{item.userName || '-'}}</div>
        @if (item.userId) {
          <div class="secondary">{{item.userId}}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let item">{{item.userEmail || '-'}}</td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let item">
        <div>{{getProductLabel(item)}}</div>
        <div class="secondary">{{item.vendorName || '-'}}</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>State</th>
      <td mat-cell *matCellDef="let item">
        <span class="status-chip" [ngClass]="getStatusChipClass(item)">{{item.statusLabel || '-'}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="retry">
      <th mat-header-cell *matHeaderCellDef>Retry</th>
      <td mat-cell *matCellDef="let item">{{getRetryLabel(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="nextRetry">
      <th mat-header-cell *matHeaderCellDef>Next Retry</th>
      <td mat-cell *matCellDef="let item">
        {{item.nextRetryAt ? (item.nextRetryAt | date:'medium') : '-'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="cancellationDate">
      <th mat-header-cell *matHeaderCellDef>Cancellation Date</th>
      <td mat-cell *matCellDef="let item">
        {{getCancellationDate(item) ? (getCancellationDate(item) | date:'medium') : '-'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="amountDue">
      <th mat-header-cell *matHeaderCellDef>Amount Due</th>
      <td mat-cell *matCellDef="let item">
        {{item.amountDue === null || item.amountDue === undefined ? '-' : (item.amountDue | currency)}}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentSource">
      <th mat-header-cell *matHeaderCellDef>Payment Source</th>
      <td mat-cell *matCellDef="let item">{{item.paymentMethodLabel || '-'}}</td>
    </ng-container>

    <ng-container matColumnDef="paymentDetails">
      <th mat-header-cell *matHeaderCellDef>Payment Details</th>
      <td mat-cell *matCellDef="let item">
        <div>{{item.paymentTypeLabel || '-'}}</div>
        @if (item.stripeStatus) {
          <div class="secondary">{{item.stripeStatus}}</div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="actions-cell">
        <button
          mat-icon-button
          class="snowman-menu-trigger"
          [matMenuTriggerFor]="actionsMenu"
          [matMenuTriggerData]="{ item: item }"
          [disabled]="!item.stripeSubscriptionId"
          aria-label="Subscription actions"
          >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading subscriptions...</div>
  }
  @if (!loading && items.data.length === 0) {
    <div class="empty">
      There are no product subscriptions to show.
    </div>
  }
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="triggerBillingCycle(item)" [disabled]="!canTriggerBillingCycle(item)">
      Trigger Billing Cycle
    </button>
  </ng-template>
</mat-menu>
